// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  refreshOverCount();
});

async function refreshOverCount() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  let count = 0;
  cart.items.forEach(i => {
    if (i.price >= 29900) count += i.quantity;
  });
  const el = document.getElementById('over-count');
  if (el) {
    el.dataset.count = count;
    el.textContent = `Gir ${count} deltakelser i giveaway`;
  }
}

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log(evt);
  if (evt.detail.variant != null) {
    /*const selectAVariantText = document.getElementById("selectAVariantText");
    selectAVariantText.hidden = true;
    
    const stickyAtcBarSelectAVariantText = document.getElementById("stickyAtcBarSelectAVariantText");
    stickyAtcBarSelectAVariantText.hidden = true;*/
  }
  updateExMvaPrices(evt.detail.variant);
  
});

function updateExMvaPrices(variant) {
  
  try {
    const compareAtExMvaEl = document.querySelector('small[data-ex-mva-compare-at-price]');
    const compareAtPrice = variant.compare_at_price;
    compareAtExMvaEl.textContent = (variant.compare_at_price / 100 * 0.8).toFixed(2);
  } catch(err) {
    console.warn("Compare at price update", err);
  }
  
  try {
    const priceExMvaEl = document.querySelector('small[data-ex-mva-price]');
    const price = variant.price;
    priceExMvaEl.textContent = (variant.price / 100 * 0.8).toFixed(2);
  } catch(err) {
    console.warn("Price update", err);
  }

  try {
    const eligableForGiveawayEl = document.querySelector('small[data-eligable-for-giveaway]');
    if (variant.price < 29900) eligableForGiveawayEl.hidden = false;
    else eligableForGiveawayEl.hidden = true;
  } catch(err) {
    console.warn("Eligable update", err);
  }
}

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});